











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'
import {EsconderMotoristaCollection} from '@/model/collection/EsconderMotoristaCollection'
import {ListEsconderMotoristaSchema} from '@/schema/resource/EsconderMotorista/ListEsconderMotoristaSchema'
import {CsvEsconderMotoristaSchema} from '@/schema/resource/EsconderMotorista/CsvEsconderMotoristaSchema'

@Component
export default class ListEsconderMotoristaView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListEsconderMotoristaSchema()
  collection = new EsconderMotoristaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: EsconderMotorista) {
    Helper.pushByName('editEsconderMotorista', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new EsconderMotoristaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvEsconderMotorista()
    new CsvEsconderMotoristaSchema().downloadCsv(csv.all())
  }
}
